<template>
	<div>
		Please confirm this company meets the following on-strategy requirements
		<ol>
			<li>Has less than USD $5 billion in yearly revenue.</li>
			<li>Is a globally oriented business with the potential for growth.</li>
			<li v-if="!hide">
				Has significant presence in countries where Boyden has offices. Please list all countries
				where the company is doing businessin the 'Countries' field below.
			</li>
			<li>Is large enough to generate ongoing executive search volume over a number of years.</li>
			<li>
				Is less bureaucratic than a large publicly traded company and is not overly centralized in
				its procurement process.
			</li>
			<li>Is not a key account target of a top 5 search firm.</li>
		</ol>
		<div v-if="!hide">Global Revenue confirmation &amp; Countries not yet implemented.</div>
	</div>
</template>
<script>
	export default {
		props: {
			hide: {
				type: Boolean,
				default: true
			}
		},
		setup(props, context) {
			return {};
		}
	};
</script>